import { render, staticRenderFns } from "./level-update-modal-first-tab.vue?vue&type=template&id=40506025&scoped=true&"
import script from "./level-update-modal-first-tab.vue?vue&type=script&lang=ts&"
export * from "./level-update-modal-first-tab.vue?vue&type=script&lang=ts&"
import style0 from "./level-update-modal-first-tab.vue?vue&type=style&index=0&id=40506025&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40506025",
  null
  
)

export default component.exports